"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

import type { ThemePreference } from "@/lib/auth/resolve-theme-preference";

// Wrapper around next-themes' ThemeProvider. Pinned to class-based
// dark mode (the @custom-variant in globals.css matches `&:is(.dark *)`).
// `enableSystem` watches prefers-color-scheme; the `system` value
// follows the OS in real time without a re-render of the rest of the
// tree.
//
// `defaultTheme` is seeded from the user's DB preference on the
// server (or "system" when no preference / unauthenticated). After
// first render, next-themes' localStorage cache becomes the source
// of truth for the same device; the Account toggle keeps both in
// sync via setTheme() + the updateThemePreference server action.

export function ThemeProvider({
  children,
  defaultTheme,
}: {
  children: React.ReactNode;
  defaultTheme: ThemePreference | null;
}) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme={defaultTheme ?? "system"}
      enableSystem
      // Avoid the post-hydration flash by suppressing transitions for
      // the first paint while next-themes resolves the active theme.
      disableTransitionOnChange
      storageKey="spr-theme"
    >
      {children}
    </NextThemesProvider>
  );
}
